import {Form} from "react-bootstrap";
import React, {useState} from "react";
import {httpClient} from "../../../service";
import {Combo, HttpMethod, JoinRequest} from "../../../model";
import TermsModal from "../../TermsModal";

const IntroductionHtml = (props: any) => {
    const [validated, setValidated] = useState(false);
    const cities: Combo[] = props.cities;
    // @ts-ignore
    const categories: Combo[] = props.categories.filter(x => x.value !== '채널' && x.value !== '월드');

    const [model, setModel] = useState<JoinRequest>({});
    const [submitting, setSubmitting] = useState(false);
    const submitForm = async (e: any) => {

        const isValid = e.currentTarget.checkValidity();
        if (!isValid) {
            e.preventDefault();
            e.stopPropagation();
            setValidated(true);
            return false;
        }
        e.preventDefault();
        const form = e.target;
        setSubmitting(true);
        console.log(`form state=${JSON.stringify(model)}`);
        const url = 'company/introduction';
        const option = {
            url: url,
            method: HttpMethod.POST,
            body: model
        };
        const act = await httpClient(option);
        setSubmitting(false);

        if (act.result) {
            alert('문의가 정상적으로 접수되었습니다.');
            const data: JoinRequest = {name: '', tel: ''};
            setModel(data);
            form.reset();
        } else {
            alert(`오류:${act.errorMsg}`);
        }
    };
    const handleInputChange = (e: any) => {
        console.log(`name=${e.target.name}, value=${e.target.value}`);
        const data = {...model, [e.target.name]: e.target.value};
        setModel(data);
    }
    const kakaoPage = 'https://pf.kakao.com/_KiMyxl';
    return (
        <>
            <div className="bloc l-bloc">
                <div className="container bloc-sm">
                    <div className="row">
                        <div className="col-lg-6 offset-lg-3 offset-md-2 col-md-8">
                            <Form id="form_539" data-form-type="blocs-form" noValidate validated={validated}
                                  onSubmit={submitForm}>
                                <Form.Group>
                                    <h6 className="mg-md subtitle">도입 문의부터&nbsp;계약, 운영까지 전문 컨설턴트가 친절히 안내해
                                        드립니다.</h6>
                                    <Form.Label
                                        className="form-label">이름 또는 매장명&nbsp;*</Form.Label>
                                    <Form.Control name="name" required onChange={handleInputChange}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        이 항목은 필수항목입니다.
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label>연락처 *</Form.Label>
                                    <Form.Control type="tel" required name="tel"
                                                  onChange={handleInputChange}></Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        이 항목은 필수항목입니다.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>지역</Form.Label>
                                    <Form.Control as="select" name="cityId" onChange={handleInputChange}>
                                        <option value="">선택</option>
                                        {
                                            cities.map(item => (
                                                <option key={item.id} value={item.id}>{item.value}</option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        이 항목은 필수항목입니다.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>업종</Form.Label>
                                    <Form.Control as="select" name="categoryId" onChange={handleInputChange}>
                                        <option value="">선택</option>
                                        {
                                            categories.map(item => (
                                                <option key={item.id} value={item.id}>{item.value}</option>
                                            ))
                                        }
                                    </Form.Control>

                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>알게된 경위</Form.Label>
                                    <Form.Control as="select" name="knowTrack" onChange={handleInputChange}>
                                        <option value="">선택</option>
                                        <option value="언론홍보">언론홍보</option>
                                        <option value="매장 또는 관광지내 홍보물">매장 또는 관광지내 홍보물</option>
                                        <option value="지역행사 또는 축제">지역행사 또는 축제</option>
                                        <option value="블로그 또는 SNS">블로그 또는 SNS</option>
                                        <option value="기타">기타</option>
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>문의 내용 *</Form.Label>
                                    <Form.Control as="textarea" onChange={handleInputChange} rows={4} cols={50} required
                                                  name="question"
                                                  placeholder="궁금하신 점이나 상담이 필요한 내용을 적어주세요">
                                    </Form.Control>
                                </Form.Group>

                                <button type="submit"
                                        className="bloc-button btn btn-d btn-lg btn-block download-bt"
                                        disabled={submitting}
                                >{submitting ? "전송중.." : "문의하기"}
                                </button>

                                <TermsModal/>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>


            <div className="bloc l-bloc">
                <div className="container bloc-sm">
                    <div className="row">
                        <div className="col-md-6 offset-md-3 offset-1 col-10 col-lg-4 offset-lg-4">
                            <a href={kakaoPage} target="_blank" rel="noopener"><img
                                src="/img/lazyload-ph.png" data-src="/img/kakaochanner_m.jpg"
                                className="img-fluid mx-auto d-block lazyload" alt="kakaochanner_m"/></a></div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default IntroductionHtml;
